import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import React, {Component, Fragment} from 'react';
import {actions as system} from '../reducers/system';
import {actions as language} from '../reducers/language';
import {actions as project} from '../reducers/project';
import { Formik, Form, Field } from 'formik';
import Select from '../components/form/Select';
import ProjectType from '../enums/ProjectType';
import _ from 'lodash';

@connect(
	state => {
		return {
			selectedProject: state.project.selected,
			languages: state.language.languages
		}
	},
	dispatch => {
		return {
			clearMessages: () => dispatch(system.clearMessages()),
			createProject: (projectToCreate) => dispatch(project.create(projectToCreate)),
			updateProject: (projectToUpdate) => dispatch(project.update(projectToUpdate)),
			fetchLanguages: () => dispatch(language.fetch())
		};
	})
export default class ProjectForm extends Component
{

	constructor(props){
		super(props);

		this.state = {
			isUpdateMode: _.has(props.match.params, 'project')
		}
	}

	componentDidMount() {
		if(this.props.languages.length === 0){
			this.props.fetchLanguages();
		}
	}

	getRedirectPath() {
		if(this.props.selectedProject){
			return '/show/' + encodeURIComponent(this.props.selectedProject.name);
		} else {
			return '/';
		}
	}

	render() {
		const initialState = this.props.selectedProject || {
			name: '',
			type: '',
			git: '',
			sourceBranch: '',
			targetBranch: '',
			languages: []
		};

		const languageCheckboxes = _.map(this.props.languages, (language, key) => {
			return (
				<Field name="languages" key={key}>
					{({ field, form }) => (
						<div className="form-check xpull-left">
							<label className="form-check-label">
								<input
									className="form-check-input"
									type="checkbox"
									checked={_.includes(field.value, language.identifier)}
									onChange={() => {
										if (_.includes(field.value, language.identifier)) {
											if (!!this.props.selectedProject)
											{
												if (this.props.selectedProject.languages.includes(language.identifier))
												{
													this.setState({
														hintLanguage: true
													})
												}
											}
											form.setFieldValue('languages', _.without(field.value, language.identifier));
										} else {
											if (!!this.props.selectedProject)
											{
												const openLanguage = [];
												_.map(this.props.selectedProject.languages, (oneLanguage) => {
													if (!field.value.includes(oneLanguage))
													{
														openLanguage.push(oneLanguage)
													}
												});
												if (openLanguage.length === 1)
												{
													if (openLanguage.includes(language.identifier))
													{
														this.setState({
															hintLanguage: false
														})
													}
												}
											}
											form.setFieldValue('languages', _.concat(field.value, language.identifier));
										}
									}}
								/>
								<span className="form-check-sign"/>
								{language.identifier}
							</label>
						</div>
					)}
				</Field>
			);
		});

		// when the form is to update wait with rendering until the project is loaded
		return this.state.isUpdateMode && this.props.selectedProject === null ? null : (
			<Fragment>
				<div className="card">
					<Formik
						initialValues={initialState}
						onSubmit={(project, actions) => {
							this.props.clearMessages();
							const promise = this.props.selectedProject ? this.props.updateProject(project) : this.props.createProject(project);
							promise.then(
								success => {
									if(success) {
										this.props.history.push('/show/' + encodeURIComponent(project.name));
									} else {
										actions.setSubmitting(false);
									}
								}
							);
						}}
						render={({ isSubmitting }) => (
							<Form>
								<div className="card-body">
									<div className="form-group has-label">
										<label>Name *</label>
										<Field type="text" className="form-control" name="name" />
									</div>
									<div className="form-group has-label">
										<label>Type *</label>
										<Select name="type" options={ProjectType.getOptions()}/>
									</div>
									<div className="form-group has-label">
										<label>Git-Repository *</label>
										<Field type="text" className="form-control" name="git" />
									</div>
									<div className="form-group has-label">
										<label>Source branch</label>
										<Field type="text" className="form-control" name="sourceBranch" />
									</div>
									<div className="form-group has-label">
										<label>Target branch *</label>
										<Field type="text" className="form-control" name="targetBranch" />
									</div>
									<div className="form-group has-label">
										<label>Languages</label>
										{languageCheckboxes}
									</div>
									<hr/>
									{this.state.hintLanguage?
										<div className='bg-danger p-3'>
											<div className='text-white'><strong>Danger Danger !!!</strong> Das Entfernen einer Sprache impliziert das Löschen aller Übersetzungen dieser Sprache in allen Sammlungen des Projekts. Bitte bestätigen.</div>
											<div>
												<div className='text-white pagination-centered'>
													<input type={'checkbox'} onChange={() => this.setState({hintLanguage: false})}/>
													Danke für den Hinweis, verstanden
												</div>
											</div>
										</div>: null
									}
								</div>

								<div className="card-footer text-right">
									<Link to={this.getRedirectPath()} className="btn btn-secondary">Cancel</Link>
									<button type="submit" className="btn btn-primary" disabled={isSubmitting || this.state.hintLanguage}>
										{this.state.isUpdateMode ? 'Update project' : 'Create project'}
									</button>
								</div>
							</Form>
						)}
					/>
				</div>
			</Fragment>
		);
	};
}


// WEBPACK FOOTER //
// ./React/src/screens/ProjectForm.js